import type React from 'react';
import DynamicLineChart from '@/components/UI/Charts/DynamicLineChart/DynamicLineChart.tsx';
import DashboardCard from './DashboardCard';

interface MilwaukeeansServedProps {
  data: {
    total: number;
    percentChange: number;
    monthLabels: string[];
    chartCounts: number[];
  };
  className?: string;
}

const MilwaukeeansServed: React.FC<MilwaukeeansServedProps> = ({ data, className }) => {
  const { total, percentChange, monthLabels, chartCounts } = data;

  return (
    <DashboardCard
      name='Milwaukeeans Served'
      header={total.toLocaleString('en-US')}
      subHeader={`${percentChange >= 0 ? '+' : ''}${percentChange.toFixed(1)}% from last month`}
      className={className}
    >
      <div className='h-32 w-full'>
        <DynamicLineChart labels={monthLabels} data={chartCounts} />
      </div>
    </DashboardCard>
  );
};

export default MilwaukeeansServed;
